meedy.directive('meedyColorButton', ['$parse',
    function($parse) {
        var definition = {
            restrict: 'E',
            scope: {
                label: '@',
                value: '=',
                colors: '=',
                required: '@?'
            },
            templateUrl: 'meedy/application/directive/meedyColorButton/template/meedy-color-button.html',
            link: function($scope, element, attr) {

                $scope.selectableColors = [];
                $scope.required = $scope.required === true;

                $scope.selectColor = function(color) {
                    if(color != $scope.value) {
                        $scope.value = color;
                    } else if(!$scope.required) {
                        $scope.value = null;
                    }
                };

            }
        };

        return definition;
    }
]);